import {
  Button, Card, CardContent, CardHeader, CircularProgress, Divider, FormControl, InputLabel, Select, TextField, Grid, ListItemText, Typography, List,
  ListItem, Backdrop, Snackbar, MenuItem
} from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import AddAlarmIcon from '@material-ui/icons/AddAlarm';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import React, { Fragment, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import Alert from 'src/components/Alert';
import DigiportIssues from 'src/components/DigiportIssues';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { getEffectiveTypeRoots } from 'typescript';
import Moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars';
import ErrorMessage from 'src/components/ErrorMessage';
const useStyles = makeStyles((theme) => ({
  root: {},
  kategoriFlex: {
    margin: theme.spacing(0),
    display: 'flex',
  },
  fieldsDigi: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  dividerDigiport: {
    backgroundColor: '#1D3343'
  },
}));


function Digiport({
  readonly, ReceiptNo, tasks, materialReducer
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [uyariOpen, setUyariOpen] = useState(false);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyariTip, setUyariTip] = useState('success');

  const [kategori, setKategori] = useState(0);
  const [aciklama, setAciklama] = useState('');
  const [malzeme, setMalzeme] = useState(false);
  const [malzemeValue, setMalzemeValue] = useState({});

  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingGonder, setLoadingGonder] = useState(false);
  const [types, setTypes] = useState([]);
  const [ContextDetail, setContextDetail] = React.useState([]);
  const SessionUser = getUser();
  const isOnline = useSelector((state) => state.status?.isOnline);

  Moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyariOpen(false);
  };

  const showAlert = (tip, msg) => {
    setUyariAciklama(msg);
    setUyariTip(tip);
    setUyariOpen(true);
  };

  const handleGonder = () => {
    if (kategori === 0) {
      showAlert('error', t('Kategori_Seciniz'));
      return;
    }
    if (aciklama.length === 0) {
      showAlert('error', t('Aciklama_Yaziniz'));
      return;
    }
    const data = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
    if (data.length === 0) {
      alert(1);
      showAlert('error', t('Fis_Bulunamadi').replace('@FisNo', ReceiptNo));
      return;
    }
    if (data[0].ModelCode === undefined || data[0].ModelCode === null || data[0].ModelCode.length === 0) {
      showAlert('error', t('Urun_Seciniz'));
      return;
    }
    if (malzeme && !malzemeValue.MaterialCode) {
      showAlert('error', t('Malzeme_Seciniz'));
      return;
    }
    setLoadingGonder(true);
    const user = getUser();

    const konu = types.filter(t => parseInt(t.id) === parseInt(kategori))[0]
      .name;
    let body = {
      Id: 0,
      serviceDeskId: '1',
      requestTypeId: kategori,
      requestFieldValues: {
        summary: konu.toString() || '',
        description: aciklama.toString() || '',
        customfield_11405: data[0].ReceiptNo.toString() || '',
        customfield_11489: data[0].SerialNumber.toString() || '',
        customfield_12508: data[0].ModelCode.toString() || '',
        QuestionUser: parseInt(SessionUser.TechnicianId) || 1,
      },
      raiseOnBehalfOf: user.UserId
    };

    if (malzeme) {
      body = {
        ...body,
        requestFieldValues: {
          ...body.requestFieldValues,
          customfield_12356: malzemeValue.MaterialCode
        }
      };
    }

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios
      .post('/SetDigiport', body, config)
      .then(response => {
        if (
          response.data !== '' &&
          response.data.issueId &&
          response.data.issueKey
        ) {
          showAlert(
            'success',
            t('Digiport_Success').replace('@issueKey', response.data.issueKey)
          );
          setKategori(0);
          setAciklama('');
        } else {
          showAlert('error', t('Error') + (response.data?.errorMessage || ''));
        }
        fecthTickets();
        setLoadingGonder(false);
      })
      .catch(error => {
        showAlert('error', t('Error'));
        fecthTickets();
        setLoadingGonder(false);
      });
  };

  const fecthTickets = () => {
    setLoading(true);
    const jql = ReceiptNo;
    axios
      .get(`/GetDigiportSearch/${jql}`)
      .then(response => {
        const Deger = response.data;
        if (Deger.length === 0) {
          setContextDetail([]);
        } else {
          setContextDetail(Deger);
        }
        setLoading(false);
      })
      .catch(error => {
        setContextDetail([]);
        setLoading(false);
      });
  };
  const handleChangeKategori = value => {
    setKategori(value);
    const type = types.filter(t => t.id === parseInt(value));
    setMalzeme(type[0].MaterialCheck);
  };

  const GetDigiportCategory = () => {
    axios.get('/GetDigiportCategory')
      .then((response) => {
        if (response.data.length > 0) {
          setTypes(response.data);
        }
      })
      .catch((error) => {

      });
  };

  React.useEffect(() => {
    fecthTickets();
    GetDigiportCategory();
  }, []);
  return (
    <div>
      <Card className={classes.cardsMax}>
        {isOnline ? (
          <Fragment>
            <Backdrop className={classes.backdrop} open={loadingGonder}>
              <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
              open={uyariOpen}
              autoHideDuration={10000}
              onClose={uyariKapat}
            >
              <Alert
                onClose={uyariKapat}
                message={uyariAciklama || ''}
                variant={uyariTip}
              />
            </Snackbar>
            <CardHeader title={t('Sorun_bildir')} />
            <Divider />
            <CardContent className={classes.content}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    value={kategori}
                    onChange={e => handleChangeKategori(e.target.value)}
                    variant="outlined"
                    label={t('lblSelectProblem')}
                  >
                    {types
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map(t => {
                        return (
                          <MenuItem key={t.id} value={t.id}>
                            {t.name}
                          </MenuItem>
                        );
                      })}
                  </TextField>
                </Grid>
                <Grid spacing={1} item xs={12} sm={12} lg={12}>
                  {malzeme && (
                    <Autocomplete
                      options={materialReducer.Data}
                      getOptionLabel={option =>
                        `${option.MaterialCode} ${option.MaterialDesc}`
                      }
                      onChange={(event, newValue) => {
                        setMalzemeValue(newValue);
                      }}
                      renderInput={params => (
                        <TextField
                          {...params}
                          label={t('Malzeme_Seciniz_input')}
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    label={t('Digiport_Aciklama')}
                    multiline
                    rows={4}
                    fullWidth
                    value={aciklama}
                    onChange={e => setAciklama(e.target.value)}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={12} style={{ textAlign: 'right' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGonder}
                    endIcon={<AddAlarmIcon>Gonder</AddAlarmIcon>}
                  >
                    {t('Gonder')}
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                <CardContent className={classes.content}>
                  <Scrollbars style={{ width: '100%', height: 200, align: 'left' }}>
                    <List className={classes.root}>
                      {ContextDetail.map((log, index) => (
                        <div key={index}>
                          <ListItem alignItems="flex-start">
                            <ListItemText
                              primary=""
                              secondary={
                                <>
                                  <Typography
                                    component="span"
                                    variant="body1"
                                    className={classes.inline}
                                    color="textPrimary"
                                  >
                                    <b>{t('Kullanici')}:</b> {log.QuestionUser}
                                    <br />
                                    <b>{t('Tarih')}:</b> {log.QuestionAskedDate === undefined ? '' : Moment(log.QuestionAskedDate).format('DD/MM/YYYY HH:mm')}
                                    <br />
                                    <b>{t('Başlık')}:</b> {log.Header}
                                    <br />
                                    <b>{t('Mesaj')}:</b> {log.Context}
                                    <br />
                                    <b>{t('Product')}:</b> {log.Product}
                                    <br />
                                    <b>{t('Material')}:</b> {log.Material}
                                    <br />
                                    <b>{t('Yanit')}:</b> {log.Answer}
                                  </Typography>
                                </>
                              }
                            />
                          </ListItem>
                        </div>
                      ))}
                    </List>
                  </Scrollbars>

                </CardContent>
              </Grid>
            </Grid>
          </Fragment>
        ) : (
          <Card>
            <CardContent>
              <ErrorMessage message={t('Offline_Message')} />
            </CardContent>
          </Card>
        )}
      </Card>
    </div>
    // <div>
    //   <Card className={classes.root}>
    //     <CardHeader title={t('Sorun_bildir')} />
    //     <Snackbar
    //       open={uyariOpen}
    //       autoHideDuration={10000}
    //       onClose={uyariKapat}
    //     >
    //       <Alert
    //         onClose={uyariKapat}
    //         message={uyariAciklama || ''}
    //         variant={uyariTip}
    //       />
    //     </Snackbar>
    //     <CardContent className={classes.content}>
    //       <div className={classes.fieldsDigi}>
    //         <FormControl variant="outlined" className={classes.kategoriFlex}>
    //           {/* <InputLabel disabled={readonly}>{t('Kategori_Seciniz')}</InputLabel> */}
    //           <Select
    //             native
    //             onChange={(e) => handleChangeKategori(e.target.value)}
    //             label="Kategori"
    //             fullWidth
    //             value={kategori}
    //           >
    //             {types.sort((a, b) => (a.name > b.name ? 1 : -1)).map((t) => <option value={t.id}>{t.name}</option>)}
    //           </Select>
    //         </FormControl>
    //       </div>
    //       {malzeme
    //         && (
    //         <div className={classes.fieldsDigi}>
    //           <FormControl variant="outlined" className={classes.kategoriFlex}>
    //             <Autocomplete
    //               options={materialReducer.Data}
    //               getOptionLabel={(option) => `${option.MaterialCode} ${option.MaterialDesc}`}
    //               onChange={(event, newValue) => {
    //                 setMalzemeValue(newValue);
    //               }}
    //               renderInput={(params) => <TextField {...params} label={t('Malzeme_Seciniz_input')} variant="outlined" />}
    //             />
    //           </FormControl>
    //         </div>
    //         )}
    //       <div className={classes.fieldsDigi}>
    //         <FormControl variant="outlined" className={classes.kategoriFlex}>
    //           <TextField
    //             label={t('Digiport_Aciklama')}
    //             multiline
    //             rows={4}
    //             fullWidth
    //             value={aciklama}
    //             onChange={(e) => setAciklama(e.target.value)}
    //             variant="outlined"
    //           />
    //         </FormControl>
    //       </div>
    //       {loadingGonder ? (
    //         <CircularProgress
    //           status="loading"
    //           style={{ marginLeft: '50%' }}
    //         />
    //       ) : (
    //         <div className={classes.fieldsDigi}>
    //           <FormControl variant="outlined" className={classes.kategoriFlex}>
    //             <Button
    //               variant="contained"
    //               color="primary"
    //               onClick={handleGonder}
    //               className={classes.submitButton}
    //               endIcon={<SendIcon>Gonder</SendIcon>}
    //             >
    //               {t('Gonder')}
    //             </Button>
    //           </FormControl>
    //         </div>
    //       )}
    //       <Divider />
    //     </CardContent>
    //     <Divider/>
    //     <Grid container spacing={1}>
    //           <Grid item xs={12} sm={12} lg={12}>
    //             <CardContent className={classes.content}>
    //               <Scrollbars style={{ width: '100%', height: 200, align: 'left' }}>
    //                 <List className={classes.root}>
    //                   {ContextDetail.map((log, index) => (
    //                     <div key={index}>
    //                       <ListItem alignItems="flex-start">
    //                         <ListItemText
    //                           primary=""
    //                           secondary={
    //                             <>
    //                               <Typography
    //                                 component="span"
    //                                 variant="body1"
    //                                 className={classes.inline}
    //                                 color="textPrimary"
    //                               >
    //                                 <b>{t('Kullanici')}:</b> {log.QuestionUser}
    //                                 <br />
    //                                 <b>{t('Tarih')}:</b> {log.QuestionAskedDate === undefined ? '' : Moment(log.QuestionAskedDate).format('DD/MM/YYYY HH:mm')}
    //                                 <br />
    //                                 <b>{t('Başlık')}:</b> {log.Header}
    //                                 <br />
    //                                 <b>{t('Mesaj')}:</b> {log.Context}
    //                                 <br />
    //                                 <b>{t('Product')}:</b> {log.Product}
    //                                 <br />
    //                                 <b>{t('Material')}:</b> {log.Material}
    //                                 <br />
    //                                 <b>{t('Yanit')}:</b> {log.Answer}
    //                               </Typography>
    //                             </>
    //                           }
    //                         />
    //                       </ListItem>
    //                     </div>
    //                   ))}
    //                 </List>
    //               </Scrollbars>

    //             </CardContent>
    //           </Grid>
    //           </Grid>
    //   </Card>
    //   <Divider className={classes.dividerDigiport} />
    // </div>
  );
}

export default connect(
  (state) => ({
    tasks: state.tasks1,
    materialReducer: state.materialReducer,
  })
)(Digiport);
